var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWsResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20311 -2012)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20311 2012)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16384.434 -3078.734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3919.078 5097.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3919.077,5108.727q0-4.131,0-8.262a2.788,2.788,0,0,1,2.933-2.947q6.163,0,12.326,0a2.834,2.834,0,0,1,2.959,2.949q.007,8.262,0,16.525a2.873,2.873,0,0,1-2.982,2.97c-4.123-.041-8.248-.014-12.372-.014a2.758,2.758,0,0,1-2.866-2.869Q-3919.081,5112.9-3919.077,5108.727Zm16.15,0q0-4.084,0-8.169c0-.8-.183-.981-.963-.982q-6.116,0-12.231,0c-.687,0-.953.249-.953.937q-.006,8.215,0,16.428c0,.717.258.957.974.957q6.094,0,12.187,0c.813,0,.987-.176.987-1Q-3902.926,5112.817-3902.927,5108.731Z",
    transform: "translate(3919.078 -5097.515)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3698.25,5191.809a4.719,4.719,0,0,1,.667.006.653.653,0,0,1,.625.685c.006.921.01,1.84,0,2.76a.609.609,0,0,1-.687.684c-.19.006-.382,0-.6,0Z",
    transform: "translate(3717.978 -5183.376)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3698.653,5130.883c0-.58.01-1.16,0-1.741-.007-.254.087-.334.333-.344.723-.029.995.209,1,.915,0,.819.005,1.637,0,2.456a.82.82,0,0,1-1.172.776c-.081-.037-.142-.209-.145-.321C-3698.66,5132.044-3698.653,5131.463-3698.653,5130.883Z",
    transform: "translate(3718.349 -5126.001)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3698.654,5256.885c0-.581.01-1.162-.005-1.742-.007-.26.1-.33.339-.338.723-.026.989.211.99.919,0,.819.006,1.637,0,2.456a.821.821,0,0,1-1.176.769c-.082-.038-.138-.211-.14-.324C-3698.662,5258.046-3698.654,5257.465-3698.654,5256.885Z",
    transform: "translate(3718.351 -5240.752)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.314 7.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3833.755,5252.139c.891,0,1.782.012,2.672-.005a.592.592,0,0,1,.608.568.581.581,0,0,1-.613.609q-2.681,0-5.362,0a.572.572,0,0,1-.6-.614.541.541,0,0,1,.6-.56Z",
    transform: "translate(3840.063 -5245.531)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3833.787,5219.618q-1.336,0-2.67,0a.533.533,0,0,1-.6-.556.571.571,0,0,1,.6-.606c1.787.007,3.573,0,5.36,0a.565.565,0,0,1,.611.585.549.549,0,0,1-.612.573Q-3832.441,5219.62-3833.787,5219.618Z",
    transform: "translate(3840.072 -5214.862)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3833.884,5185.925c-.89,0-1.781,0-2.671,0a.573.573,0,0,1-.572-.363.592.592,0,0,1,.172-.674.848.848,0,0,1,.441-.137q2.624-.014,5.248,0c.56,0,.854.456.6.9a.57.57,0,0,1-.548.277Z",
    transform: "translate(3840.169 -5184.162)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3869.6,5178.228a1.167,1.167,0,0,1,1.181,1.166,1.189,1.189,0,0,1-1.158,1.2,1.2,1.2,0,0,1-1.214-1.184A1.18,1.18,0,0,1-3869.6,5178.228Z",
    transform: "translate(3870.79 -5178.228)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3869.6,5178.228a1.167,1.167,0,0,1,1.181,1.166,1.189,1.189,0,0,1-1.158,1.2,1.2,1.2,0,0,1-1.214-1.184A1.18,1.18,0,0,1-3869.6,5178.228Z",
    transform: "translate(3870.789 -5175.219)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3869.6,5178.228a1.167,1.167,0,0,1,1.181,1.166,1.189,1.189,0,0,1-1.158,1.2,1.2,1.2,0,0,1-1.214-1.184A1.18,1.18,0,0,1-3869.6,5178.228Z",
    transform: "translate(3870.789 -5172.23)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWsResume);
export default __webpack_public_path__ + "static/media/icon-ws-resume.aa8169a3.svg";
export { ForwardRef as ReactComponent };